export const TRACKING_APP = 'content_miniapp' as const;
